import '/app/brewery-packages/content/content-editor-plugin-title/src/Title.css-raw';
export default {
  "title": "jobs-2ec46bc8-title--87Tha"
};